/*
 * Rennsieger — Carbon product page.
 *
 * Button variant picker (for the rare finish/option product), live price +
 * availability, gallery, accordions and the buy-oriented sticky. No VIN (carbon
 * fits by model). No dependencies; no-ops when its markup is absent.
 */
(function () {
  'use strict';

  var root = document.querySelector('.rsg-cp');
  if (!root) return;

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { maximumFractionDigits: 2 });
  }

  function initVariants() {
    var form = root.querySelector('#rsg-cp-form');
    var vEl = root.querySelector('[data-rsg-hp-variants]');
    var oEl = root.querySelector('[data-rsg-hp-options]');
    if (!form || !vEl || !oEl) return;

    var variants = JSON.parse(vEl.textContent);
    var optionNames = JSON.parse(oEl.textContent);
    var rows = Array.prototype.slice.call(form.querySelectorAll('[data-rsg-opt-index]'));

    var idInput = form.querySelector('[data-rsg-hp-id]');
    var priceEls = root.querySelectorAll('[data-rsg-hp-price]');
    var wasEl = root.querySelector('[data-rsg-hp-was]');
    var atc = root.querySelector('[data-rsg-hp-atc]');
    var atcLabel = root.querySelector('[data-rsg-hp-atc-label]');
    var stickyPrice = root.querySelector('[data-rsg-sticky-price]');

    var selected = optionNames.map(function (_, i) {
      var r = form.querySelector('[data-rsg-opt-index="' + i + '"]');
      if (r) {
        var sel = r.querySelector('.is-sel') || r.querySelector('[data-value]');
        return sel ? sel.getAttribute('data-value') : '';
      }
      return variants[0] ? variants[0]['option' + (i + 1)] : '';
    });

    function findVariant(vals) {
      for (var k = 0; k < variants.length; k++) {
        var m = true;
        for (var i = 0; i < vals.length; i++) {
          if (variants[k]['option' + (i + 1)] !== vals[i]) { m = false; break; }
        }
        if (m) return variants[k];
      }
      return null;
    }

    function render() {
      var cur = findVariant(selected);
      rows.forEach(function (row, i) {
        row.querySelectorAll('[data-rsg-opt-btn]').forEach(function (btn) {
          var val = btn.getAttribute('data-value');
          var trial = selected.slice(); trial[i] = val;
          var vr = findVariant(trial);
          btn.classList.toggle('is-soldout', !(vr && vr.available));
          btn.classList.toggle('is-sel', selected[i] === val);
        });
      });
      if (!cur) { if (atc) atc.disabled = true; if (atcLabel) atcLabel.textContent = 'Unavailable'; return; }
      if (idInput) idInput.value = cur.id;
      priceEls.forEach(function (el) { el.textContent = money(cur.price); });
      if (atc) atc.disabled = !cur.available;
      if (atcLabel) atcLabel.textContent = cur.available ? 'Add to cart' : 'Sold out';
      if (wasEl) {
        if (cur.compare_at_price && cur.compare_at_price > cur.price) { wasEl.textContent = money(cur.compare_at_price); wasEl.hidden = false; }
        else { wasEl.hidden = true; }
      }
      if (stickyPrice) stickyPrice.textContent = money(cur.price);
    }

    rows.forEach(function (row, i) {
      row.querySelectorAll('[data-rsg-opt-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () { selected[i] = btn.getAttribute('data-value'); render(); });
      });
    });
    render();
  }

  function initGallery() {
    var main = root.querySelector('[data-rsg-gal-main]');
    var thumbs = root.querySelector('[data-rsg-gal-thumbs]');
    if (!main) return;
    var imgs = Array.prototype.slice.call(main.querySelectorAll('img'));
    function show(i) {
      imgs.forEach(function (m) { m.classList.toggle('is-on', +m.getAttribute('data-i') === i); });
      if (thumbs) thumbs.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-on', +b.getAttribute('data-i') === i); });
    }
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () { show(+b.getAttribute('data-i')); });
    });
  }

  function initAcc() {
    root.querySelectorAll('[data-rsg-acc] .rsg-acc__q').forEach(function (q) {
      q.addEventListener('click', function () {
        var a = q.nextElementSibling;
        var open = q.classList.contains('is-open');
        q.classList.toggle('is-open', !open);
        a.style.maxHeight = open ? null : a.scrollHeight + 'px';
      });
    });
  }

  function initSticky() {
    var bar = root.querySelector('[data-rsg-sticky]');
    var buy = root.querySelector('[data-rsg-hp-buy]');
    if (!bar || !buy) return;
    var btn = bar.querySelector('[data-rsg-sticky-btn]');
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { bar.classList.toggle('is-shown', !en[0].isIntersecting); }, { threshold: 0 }).observe(buy);
    }
    if (btn) btn.addEventListener('click', function () { buy.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  }

  function boot() { initVariants(); initGallery(); initAcc(); initSticky(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else { boot(); }
})();
